import script from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./AudioStylePanel.vue?vue&type=style&index=0&id=32517bcf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32517bcf"]])

export default __exports__